import { render, staticRenderFns } from "./popSetTag.vue?vue&type=template&id=4d879e30"
import script from "./popSetTag.vue?vue&type=script&lang=js"
export * from "./popSetTag.vue?vue&type=script&lang=js"
import style0 from "./popSetTag.vue?vue&type=style&index=0&id=4d879e30&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d879e30')) {
      api.createRecord('4d879e30', component.options)
    } else {
      api.reload('4d879e30', component.options)
    }
    module.hot.accept("./popSetTag.vue?vue&type=template&id=4d879e30", function () {
      api.rerender('4d879e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popSetTag/popSetTag.vue"
export default component.exports